import React from 'react';
import { Card, CardContent, CardMedia, Typography, Button, Box, List, ListItem } from '@mui/material';

function ClientAcquisitionCard() {
  return (
    <Card sx={{
      display: 'flex',
      flexDirection: { xs: 'column', md: 'row' }, // Stack on small screens, row on medium and up
      justifyContent: 'space-between',
      alignItems: 'center',
      boxShadow: 3,
    }}>
      <Box sx={{
        display: 'flex',
        flexDirection: 'column',
        width: { xs: '100%', md: 'auto' }, // Full width on small screens, auto width on medium and up
      }}>
        <CardContent sx={{ flex: '1 0 auto' }}>
          <Typography component="div" variant="h5">
            CLIENT ACQUISITION & LEAD MANAGEMENT
          </Typography>
          <Typography variant="subtitle1" color="text.secondary" component="div">
            TRANSFORM LEADS TO TRANSACTIONS
          </Typography>
          <List>
            <ListItem>Real-time Notifications</ListItem>
            <ListItem>Instantly Interact with Consumer</ListItem>
            <ListItem>Lead/Client Pipelines</ListItem>
            <ListItem>KPI Dashboard</ListItem>
            <ListItem>Partner Access/Lead Management</ListItem>
            <ListItem>Integration to LOS/POS/CRM</ListItem>
          </List>
        </CardContent>
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', p: 2 }}>
          <Button size="small" color="primary">
            LEARN MORE
          </Button>
        </Box>
      </Box>
      <CardMedia
        component="img"
        sx={{ 
          width: { xs: '100%', sm: 151 }, // Full width on extra-small screens, fixed width on small and up
          height: { xs: 'auto', sm: 151 }, // Auto height for responsive image scaling on small screens
        }}
        image="/assets/toolscreenshot.JPG" // Replace with the path to your image
        alt="UI Screenshot"
      />
    </Card>
  );
}

export default ClientAcquisitionCard;
